import {hrmsWithPath} from "../../services/http/api/rest";

const rest = hrmsWithPath('/v1/poll');

const poll = {
    search: (data?: any) => rest.post('/search', {}, data ?? {}, {}),
    create: (data: any) => rest.post('', {}, data, {}),
    vote: (id: string) => rest.put('/option-id/{{id}}/vote', {id}, {}, {}),
    end: (id: string) => rest.put('/{{id}}/end-poll', {id}, {}, {}),
    declareResult: (id: string) => rest.put('/declare-result/{{id}}', {id}, {}, {}),
    getResult: (id: string) => rest.get('/result/{{id}}', {id}, {}),
    getAdminResults: (id: string) => rest.get('/preview-result/{{id}}', {id}, {})
}

export default poll;